import validate from "/app/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@18.19.63_eslint@9.14.0_jiti@2.4.2__ioredis@5.4._xufnbkyl3mdlyhamyfolzcxq7m/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45trailing_45slash_45global from "/app/middleware/01.trailing-slash.global.ts";
import _02_45redirects_45global from "/app/middleware/02.redirects.global.ts";
import _03_45redirect_45to_45old_45site_45global from "/app/middleware/03.redirect-to-old-site.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@18.19.63_eslint@9.14.0_jiti@2.4.2__ioredis@5.4._xufnbkyl3mdlyhamyfolzcxq7m/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45trailing_45slash_45global,
  _02_45redirects_45global,
  _03_45redirect_45to_45old_45site_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "prefetch-blog-article-page": () => import("/app/middleware/prefetch-blog-article-page.ts"),
  "prefetch-blog-category-page": () => import("/app/middleware/prefetch-blog-category-page.ts"),
  "prefetch-blog-tag-page": () => import("/app/middleware/prefetch-blog-tag-page.ts"),
  "prefetch-dynamic-page": () => import("/app/middleware/prefetch-dynamic-page.ts"),
  "prefetch-locations-map-page": () => import("/app/middleware/prefetch-locations-map-page.ts"),
  "prefetch-news-article-page": () => import("/app/middleware/prefetch-news-article-page.ts"),
  "prefetch-search-page": () => import("/app/middleware/prefetch-search-page.ts")
}